<script>
	import { formMap } from "../stores.js";
	import Svelecte from "svelecte";

	export let conditions;

	let forms = Object.keys($formMap);
	let formsSelected = [];

	const getStorage = () => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		if (params) {
			if (params.formsSelected) {
				formsSelected = params["formsSelected"];
			}
		} else {
			params = {};
		}
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};
	getStorage();
	$: getStorage(conditions);

	const updateStorage = (parameters) => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		params["formsSelected"] = parameters;
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};
	$: updateStorage(formsSelected);

	const formatForAPI = (conditions, parameters, parameterName) => {
		let paramsSelected = JSON.parse(
			localStorage.getItem("createStudyParamsSelected")
		);
		let formatted = [];
		for (let i = 0; i < conditions; i++) {
			formatted.push({
				condition: i + 1,
				param: parameterName,
				value: parameters, // duplicate for all conditions
			});
		}
		if (paramsSelected) {
			paramsSelected[parameterName] = formatted;
		} else {
			paramsSelected = {};
			paramsSelected[parameterName] = formatted;
		}
		localStorage.setItem(
			"createStudyParamsSelected",
			JSON.stringify(paramsSelected)
		);
	};
	$: formatForAPI(conditions, formsSelected, "forms");
</script>

<section>
	<hr />
	<h3>Post-experiment questionnaires</h3>
	<p>
		Select questionnaires (in the required order) to show. See
		questionnaires <a href="/viewforms" target="_blank">here</a>.
	</p>
	<Svelecte
		options={forms}
		labelAsValue={true}
		multiple
		placeholder="Order matters!"
		style="width:100%"
		bind:value={formsSelected}
	/>
</section>

<style>
</style>
